import { render, staticRenderFns } from "./employeeDetail.vue?vue&type=template&id=aa86de40&scoped=true&"
import script from "./employeeDetail.vue?vue&type=script&lang=js&"
export * from "./employeeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa86de40",
  null
  
)

export default component.exports